import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["feedbackUrl"];
import React from 'react';
import { useIntl } from 'react-intl-next';
import { messages } from '../messages';
import AdvancedSearchFooter from '../../../advanced-search-footer';
import { SearchFooterWrapper, FeedbackLinkWrapper, FeedbackLink } from './styled';
export var TrelloFooter = function TrelloFooter(_ref) {
  var feedbackUrl = _ref.feedbackUrl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(SearchFooterWrapper, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, rest), /*#__PURE__*/React.createElement(FeedbackLinkWrapper, null, /*#__PURE__*/React.createElement(FeedbackLink, {
    appearance: "subtle-link",
    href: feedbackUrl,
    target: "_blank"
  }, formatMessage(messages.trello_feedback_link))));
};